import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
const features = ['Unlimited kitties for every group', 'Invite as many friends as you want', 'Balances settle automatically', 'Log expenses in seconds', 'See who owes what in real time', 'Get your money back when you leave'];
export function Pricing() {
  const scrollToWaitlist = () => {
    document.getElementById('waitlist')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="pricing" className="py-28 lg:py-36 bg-gray-50" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-171">
          <p className="text-sm font-semibold text-kitty-yellow-600 uppercase tracking-widest mb-3" data-id="element-172">
            Pricing
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-173">
            Completely free. Seriously.
          </h2>
          <p className="text-lg text-gray-500 max-w-lg mx-auto" data-id="element-174">
            No subscriptions. No hidden fees. Just group money, simplified.
          </p>
        </motion.div>

        <div className="max-w-lg mx-auto" data-id="element-175">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-176">
            {/* Yellow top accent line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-177" />

            <div className="text-center mb-10 mt-2" data-id="element-178">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-4" data-id="element-179">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-180" />
                Available at launch
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-181">
                <span className="text-5xl md:text-6xl font-extrabold text-kitty-dark" data-id="element-182">
                  £0
                </span>
                <span className="text-gray-400 text-lg" data-id="element-183">/month</span>
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-184">
              {features.map(feature => <li key={feature} className="flex items-center gap-3" data-id="element-185">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-186">
                    <CheckIcon className="w-3.5 h-3.5 text-green-600" data-id="element-187" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-188">{feature}</span>
                </li>)}
            </ul>

            <button onClick={scrollToWaitlist} className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-all active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-189">
              Get Early Access
              <ArrowRightIcon className="w-5 h-5" data-id="element-190" />
            </button>

            {/* Early access note */}
            <p className="text-center text-xs text-gray-500 mt-5 font-medium" data-id="element-191">
              🚀 Limited spots — join early access now
            </p>

            <p className="text-center text-xs text-gray-400 mt-3" data-id="element-192">
              Small fee on deposits (2.5% + 25p) to cover secure payment
              processing and support KittyPot — everything else is completely
              free. Standard refunds are free, instant refunds come at a 1.9%
              fee.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}